<template>
  <span>
    <eurus-header></eurus-header>
    <div class="container">
      <eurus-banner></eurus-banner>
      <div class="col-sm-3">
        <eurus-sidebar></eurus-sidebar>
      </div>
      <div class="col-sm-9" id="main-router-view">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
  </span>
</template>

<script>
    import Header from './components/Header.vue';
    import Banner from './components/Banner.vue';
    import Sidebar from './components/Sidebar.vue';

    export default {
        components: {
            'eurus-header': Header,
            'eurus-banner': Banner,
            'eurus-sidebar': Sidebar
        },
        data () {
            return {}
        }
    }
</script>

<style>
  .active > a {
    color : white
  }
  @media (max-width:767px) {
    .eurus-image {
      display: none;
    }
  }
</style>


// WEBPACK FOOTER //
// App.vue?e0fde246